type Props = {
  price: number;
};

export function ItemPrice({ price }: Props) {
  return <div className="text-yellow-500">{priceFormat(price.toString())}</div>;
}

export function priceFormat(price: string | number) {
  const str = String(price);
  const s = str.length;
  const chars = str.split("");
  const strWithSpaces = chars.reduceRight((acc, char, i) => {
    const spaceOrNothing = (s - i) % 3 === 0 ? " " : "";
    return spaceOrNothing + char + acc;
  }, "");
  return strWithSpaces[0] === " " ? strWithSpaces.slice(1) : strWithSpaces;
}
